import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as estimate from './types';

const mutations = {
  [estimate.SET_ESTIMATION](state, data) {
    if (data && data.createdAt) {
      data.createdAt = format(parseISO(data.createdAt), 'yyyy-MM-dd');
    }
    state.estimation = data;
  },
  [estimate.SET_AUTO_ESTIMATION](state, data) {
    if (data && data.createdAt) {
      data.createdAt = format(parseISO(data.createdAt), 'yyyy-MM-dd');
    }
    state.autoEstimation = data;
  },
  [estimate.SET_ESTIMATION_LIST](state, data) {
    if (data.content) {
      data.content.forEach(element => {
        if (element.createdAt) {
          element.createdAt = format(parseISO(element.createdAt), 'yyyy-MM-dd');
        }
      });
    }
    state.estimationList.content = data.content;
    state.estimationList.pagination = data.pagination;
  },

  [estimate.ESTIMATION_ALL_RESET_STATE](state) {
    state.estimation = {};
    state.estimationList = {};
  },

  [estimate.SET_QUOTATION](state, data) {
    state.quotation = data;
  },

  [estimate.SET_QUOTATION_LIST](state, data) {
    if (data.content) {
      data.content.forEach(element => {
        if (element.createdAt) {
          element.createdAt = format(parseISO(element.createdAt), 'yyyy-MM-dd');
        }
      });
    }
    state.quotationList.content = data.content;
    state.quotationList.pagination = data.pagination;
  },

  [estimate.QUOTATION_RESET_STATE](state) {
    state.quotation = {
      deviceIdx: '',
      deviceName: '',
      isChangeDevice: false,
      divMonth: '24',
      divMonthName: '24개월',
      estimateId: [],
      estimateSendView: [],
      factoryPrice: 0,
      info: '',
      interestYn: '',
      manufacturerId: '',
      manufacturerName: '',
      modelName: '',
      planIdx: '',
      planName: '',
      policy: 0,
      price: 0,
      storeSupportMoney: 0,
      supportMoney: 0,
      supportMoneyDt: '',
      telecomId: '',
      telecomName: '',
      userId: [],
      storeName: '',
      isFromChat: false,
      isDetail: false,
      isSendChatMessage: false,
      welfareId: '',
      welfareDetail: '',
      welfareFixedAmount: 0,
      welfareFixedRate: 0,
      welfareMaxAmount: 0,
      welfareText: '',
      planPeriod: '183일',
      planTypeIdx: '',
      planTypeName: '',
      planTypePrice: 0,
      planTypeSupportMoney: 0,
      planTypeSupportMoneyDt: '',
      planVoice: '',
      planSms: '',
      planData: '',
      planVideo: '',
    };
  },

  [estimate.SET_ESTIMATION_MODEL](state, data) {
    state.estimationModel = data;
  },

  [estimate.ESTIMATION_MODEL_RESET_STATE](state) {
    state.estimationModel = {
      targetName: '', //대상(1:본인,2:부,3:모,4:자녀)
      targetAgeName: '', // 대상연령대(1:18세이상,2:18세이하,3:12세이하,4:모르겠음)
      target: 1, //대상(1:본인,2:부,3:모,4:자녀)
      targetAge: 1, // 대상연령대(1:18세이상,2:18세이하,3:12세이하,4:모르겠음)
      telecomId: '',
      telecomName: '',
      currentDeviceIdx: '',
      currentDeviceName: '',
      currentManufacturerId: '',
      currentManufacturerName: '',
      currentModelName: '',
      needDeviceIdx: '',
      needDeviceName: '',
      needManufacturerId: '',
      needManufacturerName: '',
      needModelName: '',
      dataUsage: 0,
      internetUsage: 0,
      period: 0,
      storeId: 0,
      telecomMaintance: 0,
      steps: 1,
      type: 'DEFAULT',
    };
  },
  [estimate.SET_ESTIMATION_REQUEST_AT](state, data) {
    for (let i = 0; i < state.estimationList.content.length; i++) {
      const estimate = state.estimationList.content[i];
      if (estimate.id === data.estimateId) {
        estimate.requestedAt = new Date().toISOString();
      }
    }
  },
};

export default mutations;
